module.exports = __webpack_public_path__ + "img/follow-icon_superlive.a1254fdf.svg";